module.exports = __webpack_public_path__ + "static/img/ground6.5a1ad737.png";